<template>
  <v-container>
    <v-layout align-center>
      <v-flex xs10>
        <h3 class="primary--text">Agenda</h3>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs2 text-xs-right>
        <v-switch
          :label="`${pesquisaModel.ativo ? 'Minhas agendas' : 'Todas agendas'}`"
          v-model="pesquisaModel.ativo"
          @change="buscarAgendas()"
          color="primary"
        ></v-switch>
      </v-flex>
      <v-flex xs1 text-xs-right>
        <v-tooltip color="secondary" bottom>
          <v-btn
            slot="activator"
            dark
            small
            color="secondary"
            @click="agendar()"
            depressed
          >
            <v-icon>add</v-icon>
          </v-btn>
          <span>Adicionar uma nova agenda</span>
        </v-tooltip>
      </v-flex>
      <v-flex xs1 text-xs-right>
        <v-tooltip color="secondary" bottom>
          <v-btn
            slot="activator"
            dark
            small
            color="secondary"
            @click="go('AgendaLista')"
            depressed
          >
            <v-icon>list</v-icon>
          </v-btn>
          <span>Ir para Agenda em lista</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex sm4 xs12 class="text-sm-left text-xs-center">
        <v-btn @click="$refs.calendar.prev()">
          <v-icon dark left>keyboard_arrow_left</v-icon>Anterior
        </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex sm4 xs12 class="text-sm-right text-xs-center">
        <v-btn @click="$refs.calendar.next()">
          Proximo
          <v-icon right dark>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-sheet height="500">
          <!-- now is normally calculated by itself, but to keep the calendar in this date range to view events -->
          <v-calendar
            ref="calendar"
            :now="today"
            :value="today"
            :end="end"
            v-model="today"
            color="primary"
            type="week"
            locale="pt-br"
            :first-interval="14"
            :interval-minutes="30"
            :interval-count="26"
            :show-month-on-first="true"
          >
            <!-- the events at the top (all-day) -->
            <!-- <template v-slot:dayHeader="{ date }">
            <template v-for="event in eventsMap[date]">-->
            <!-- all day events don't have time -->
            <!-- <div
                  v-if="!event.hora"
                  :key="event.titulo"
                  class="my-event"
                  @click="open(event)"
                  v-html="event.titulo"
                ></div>
              </template>
            </template>-->
            <!-- the events at the bottom (timed) -->
            <template v-slot:dayBody="{ date, timeToY, minutesToPixels }">
              <template v-for="(event, index) in eventsMap[date]">
                <!-- <template v-for="(event, index) in eventsMap[date]"> -->
                <!-- timed events -->
                <div
                  v-if="event.hora"
                  :key="event.idAgenda"
                  :style="{
                    top: timeToY(event.hora) + 'px',
                    height: minutesToPixels(event.duracao - 1) + 'px',
                    marginLeft:
                      dataIguaisML(eventsMap[date], event.hora, index, event.idAgenda) + '%',
                    width: dataIguaisWidth(eventsMap[date], event.hora) + '%',
                  }"
                  class="my-event with-time"
                  @click="open(event)"
                  v-html="
                    event.titulo +
                    '</br>' +
                    (event.pessoa === null
                      ? event.empresa.nome
                      : event.pessoa.nome)
                  "
                ></div>
                <!-- <div
                  v-if="event.hora"
                  :key="event.titulo"
                  :style="{ top: timeToY(event.hora) + 'px', height: minutesToPixels(event.duracao) + 'px', marginLeft: dataIguais(eventsMap[date], event.hora, index) + 'px', : '40px'  }"
                  class="my-event with-time"
                  @click="open(event)"
                  v-html="event.titulo +'</br>' + (event.pessoa === null ? event.empresa.nome : event.pessoa.nome )"
                ></div> -->
              </template>
            </template>
          </v-calendar>
        </v-sheet>
      </v-flex>
      <v-dialog
        v-model="dialogDetalhes"
        max-width="900px"
        @mousedown="closeDetalhes()"
      >
        <v-card>
          <v-card-title class="pt-0">
            <span class="headline pb-0"
              >Titulo: {{ agenda === null ? "n/d" : agenda.titulo }}</span
            >
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="closeDetalhes"
              >Fechar</v-btn
            >
          </v-card-title>
          <v-card-text class="pt-0">
            <v-container grid-list-md class="pa-0">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 md12
                    >Data:
                    {{
                      agenda === null
                        ? "n/d"
                        : customFormatComputed.toLocaleDateTimeString(
                            agenda.data + "T" + agenda.hora + ":00"
                          )
                    }}</v-flex
                  >
                  <v-flex xs12 md12
                    >Tipo:
                    {{
                      agenda === null ? "n/d" : agenda.tipoCompromisso.nome
                    }}</v-flex
                  >
                  <v-flex xs12 md12
                    >Duração:
                    {{ agenda === null ? "n/d" : agenda.duracao }}
                    minutos</v-flex
                  >
                  <v-flex
                    v-if="agenda != null && agenda.pessoa != null"
                    xs12
                    md12
                    >Pessoa:
                    {{
                      agenda === null
                        ? "n/d"
                        : agenda.pessoa.nome +
                          " Cod.: " +
                          agenda.pessoa.idPessoa
                    }}</v-flex
                  >
                  <v-flex
                    v-if="agenda != null && agenda.empresa != null"
                    xs12
                    md12
                    >Empresa:
                    {{
                      agenda === null
                        ? "n/d"
                        : agenda.empresa.nome +
                          " Cod.: " +
                          agenda.empresa.idEmpresa
                    }}</v-flex
                  >
                  <v-flex
                    xs12
                    md12
                    v-if="agenda != null && agenda.pessoa != null"
                    >Contato:
                    {{
                      agenda === null ? "n/d" : agenda.pessoa.whatapp
                    }}</v-flex
                  >
                  <v-flex
                    xs12
                    md12
                    v-if="agenda != null && agenda.empresa != null"
                    >Contato:
                    {{
                      agenda === null ? "n/d" : agenda.empresa.whatapp
                    }}</v-flex
                  >
                  <v-flex xs12 md12
                    >Usuário Criador:
                    {{
                      agenda === null ? "n/d" : agenda.usuarioCriador.nome
                    }}</v-flex
                  >
                  <v-flex xs12 md12
                    >Usuário Responsável:
                    {{
                      agenda === null ? "n/d" : agenda.usuarioResponsavel.nome
                    }}</v-flex
                  >
                  <v-flex xs12 md12>Descrição:</v-flex>
                  <v-flex xs12 md12>{{
                    agenda === null ? "n/d" : agenda.texto
                  }}</v-flex>
                  <v-flex xs12 md12
                    >Data Inclução:
                    {{
                      agenda === null
                        ? "n/d"
                        : customFormatComputed.toLocaleDateTimeString(
                            agenda.dataIncluso
                          )
                    }}</v-flex
                  >
                </v-layout>
              </v-card-text>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogAgendar"
        max-width="900px"
        @mousedown="closeAgendar()"
      >
        <v-card>
          <v-card-title class="pt-0">
            <span class="headline pb-0">Agendar Novo Compromiso</span>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="closeAgendar"
              >Fechar</v-btn
            >
          </v-card-title>
          <v-card-text class="pt-0">
            <v-form
              v-model="formularioCadastroValido"
              ref="formularioCadastroRef"
            >
              <v-container grid-list-md class="pa-0">
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 md12>
                      <v-autocomplete
                        v-model="modeloAgenda.pessoa"
                        :items="listaPessoas"
                        item-text="nome"
                        prepend-icon="people"
                        label="Qual Pessoa?"
                        :rules="regras.branco"
                        riquired
                        return-object
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md12>
                      <v-text-field
                        v-model="modeloAgenda.titulo"
                        color="secondary"
                        prepend-icon="chrome_reader_mode"
                        label="Titulo"
                        :rules="regras.branco50"
                        riquired
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md4>
                      <v-menu
                        ref="menuCalendarDataAgenda"
                        :close-on-content-click="false"
                        v-model="menuCalendarDataAgenda"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                        :return-value.sync="modeloAgenda.data"
                      >
                        <v-text-field
                          slot="activator"
                          v-model="dataAgendaFormatada"
                          label="Data"
                          prepend-icon="event"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          ref="picker"
                          v-model="modeloAgenda.data"
                          locale="pt-br"
                          :rules="regras.branco"
                          required
                          @input="
                            $refs.menuCalendarDataAgenda.save(modeloAgenda.data)
                          "
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 md4>
                      <v-dialog
                        ref="dialog"
                        v-model="modalHora"
                        :return-value.sync="modeloAgenda.hora"
                        persistent
                        lazy
                        full-width
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="modeloAgenda.hora"
                            label="Hora"
                            prepend-icon="access_time"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="modalHora"
                          v-model="modeloAgenda.hora"
                          full-width
                          :landscape="false"
                          format="24hr"
                          min="07:30"
                          max="19:00"
                          riquired
                          :rules="regras.branco"
                        >
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="modalHora = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            flat
                            color="primary"
                            @click="$refs.dialog.save(modeloAgenda.hora)"
                            >OK</v-btn
                          >
                        </v-time-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model="modeloAgenda.duracao"
                        color="secondary"
                        prepend-icon="chrome_reader_mode"
                        label="Duração em min."
                        type="number"
                        :rules="regras.branco"
                        riquired
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md8>
                      <v-select
                        v-model="modeloAgenda.usuarioResponsavel"
                        color="secondary"
                        :items="listaUsuarios"
                        :rules="regras.branco"
                        item-text="nome"
                        prepend-icon="business_center"
                        label="Usuário Responsável"
                        return-object
                        riquired
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 md4>
                      <v-switch
                        :label="`${modeloAgenda.ativo ? 'Ativo' : 'Inativo'}`"
                        v-model="modeloAgenda.ativo"
                        color="primary"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 md12>
                      <v-textarea
                        v-model="modeloAgenda.texto"
                        color="secondary"
                        label="Descrição"
                        type="text"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    id="fechar"
                    color="primary"
                    class="grey--text text--darken-1"
                    @click="closeAgendar"
                    flat
                    >Voltar</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    id="finalizar"
                    color="primary"
                    class="default-border"
                    depressed
                    :disabled="disableBtnFinalizar || !formValid"
                    @click="finalizar"
                    >Finalizar</v-btn
                  >
                </v-card-actions>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-snackbar
      :timeout="3200"
      :color="`${snackbarModel.sucesso ? 'success' : 'error'}`"
      v-model="snackbarModel.mostrar"
      bottom
      multi-line
    >
      {{ snackbarModel.text }}
      <v-btn dark flat @click.native="snackbarModel.mostrar = false"
        >Fechar</v-btn
      >
    </v-snackbar>
  </v-container>
</template>

<script>
import customFormat from "@/helpers/custom-format.js";
import jwt from "@/helpers/jwt";

export default {
  name: "Agendas",
  data: () => ({
    loading: false,
    search: null,
    formularioCadastroValido: false,
    disableBtnFinalizar: false,
    menuCalendarDataAgenda: false,
    dataAgendaFormatada: null,
    modalHora: false,
    dialogDetalhes: false,
    dialogAgendar: false,
    today: new Date().toISOString().split("T")[0],
    end: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
      .toISOString()
      .split("T")[0],
    listaAgendas: [],
    listaUsuarios: [],
    listaPessoas: [],
    agenda: null,
    pesquisaModel: {
      ativo: false,
    },
    snackbarModel: {
      mostrar: false,
      sucesso: false,
      text: "",
    },
    modeloAgenda: {
      pessoa: null,
      tipoCompromisso: { idTipoCompromisso: 1 },
      data: null,
      hora: null,
      duracao: 30,
      titulo: "",
      texto: null,
      usuarioCriador: {
        idUsuario: jwt.decryptToken().id,
      },
      usuarioResponsavel: null,
      conta: {
        idConta: jwt.decryptToken().idconta,
      },
      ativo: true,
    },
    regras: {
      branco: [(v) => !!v || "Você não pode deixar este campo em branco"],
      branco50: [
        (v) => !!v || "Você não pode deixar este campo em branco",
        (v) =>
          v.length < 50 ||
          "O campo deve ter 50 caracteres no maximo ou mais caracteres",
      ],
    },
  }),
  watch: {
    dialogDetalhes(val) {
      const self = this;
      if (!val) {
        self.closeDetalhes();
      }
    },
    dialogDetalhes(val) {
      const self = this;
      if (!val) {
        self.closeDetalhes();
      }
    },
    "modeloAgenda.data": function (val) {
      this.dataAgendaFormatada = val
        ? new Date(val).toLocaleDateString("pt-br", { timeZone: "UTC" })
        : "";
    },
  },
  mounted: function () {
    this.buscarAgendas();
    this.externalSnackbarMessage();
  },
  computed: {
    // convert the list of events into a map of lists keyed by date
    eventsMap() {
      const map = {};
      this.listaAgendas.forEach((e) =>
        (map[e.data] = map[e.data] || []).push(e)
      );
      return map;
    },
    customFormatComputed: function () {
      return customFormat;
    },
    formValid: function () {
      return this.formularioCadastroValido;
    },
  },
  methods: {
    buscarUsuarios: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        self.$http
          .get(
            `${process.env.URL_API}/usuario/v1/busca/nome/conta/ativas/` +
              jwt.decryptToken().idconta,
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            }
          )
          .then(function (response) {
            self.listaUsuarios = response.data;
            self.listaUsuarios.sort(self.customFormatComputed.compareNome);
          });
      } else {
        self.go("Login");
      }
    },
    finalizar() {
      const self = this;
      self.$store.commit("startLoading");
      if (self.$refs.formularioCadastroRef.validate()) {
        const item = jwt.decryptToken();
        if (item != null) {
          if (!self.$route.params.id) {
            self.$http
              .post(
                `${process.env.URL_API}/agenda/v1/cadastro`,
                self.modeloAgenda,
                {
                  headers: {
                    Authorization:
                      "Bearer " + JSON.parse(localStorage.getItem("token")),
                  },
                }
              )
              .then(function (response) {
                const data = response.data;
                if (data.sucesso) {
                  self.disableBtnFinalizar = data.sucesso;
                  self.closeAgendar();
                  self.buscarAgendas();
                } else {
                  self.snackbarModel.text = data.mensagem;
                  self.snackbarModel.mostrar = true;
                  self.snackbarModel.sucesso = data.sucesso;
                  self.disableBtnFinalizar = data.sucesso;
                }
              })
              .catch(function (error) {
                self.snackbarModel.text = error.response.data.message;
                self.snackbarModel.sucesso = false;
                self.snackbarModel.mostrar = true;
                self.disableBtnFinalizar = false;
              });
          }
        } else {
          self.go("Login");
        }
      }
      self.$store.commit("endLoading");
    },
    agendar() {
      const self = this;
      self.buscarUsuarios();
      self.buscarPessoas();
      self.dialogAgendar = true;
    },
    closeAgendar() {
      const self = this;

      self.modeloPessoa = null;
      self.modeloAgenda.data = null;
      self.modeloAgenda.hora = null;
      self.modeloAgenda.duracao = 30;
      self.modeloAgenda.texto = null;
      self.modeloAgenda.usuarioResponsavel = null;
      self.modeloAgenda.titulo = "";

      self.dialogAgendar = false;
    },
    closeDetalhes() {
      const self = this;

      self.dialogDetalhes = false;
    },
    buscarAgendas: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        if (self.pesquisaModel.ativo) {
          self.$http
            .get(
              `${process.env.URL_API}/agenda/v1/busca/ativas/usuario/` +
                jwt.decryptToken().id,
              {
                headers: {
                  Authorization:
                    "Bearer " + JSON.parse(localStorage.getItem("token")),
                },
              }
            )
            .then(function (response) {
              self.listaAgendas = response.data;
            });
        } else {
          self.$http
            .get(
              `${process.env.URL_API}/agenda/v1/busca/ativas/conta/` +
                jwt.decryptToken().idconta,
              {
                headers: {
                  Authorization:
                    "Bearer " + JSON.parse(localStorage.getItem("token")),
                },
              }
            )
            .then(function (response) {
              self.listaAgendas = response.data;
            });
        }
      } else {
        self.go("Login");
      }
    },
    buscarPessoas: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        self.$http
          .get(
            `${process.env.URL_API}/pessoa/v1/busca/simples/conta/` +
              jwt.decryptToken().idconta,
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            }
          )
          .then(function (response) {
            self.listaPessoas = response.data;
          });
      } else {
        self.go("Login");
      }
    },
    open(event) {
      const self = this;
      self.agenda = event;
      self.dialogDetalhes = true;
    },
    externalSnackbarMessage: function () {
      const self = this;
      if (self.$route.params.snackbarMostrar) {
        self.snackbarModel.sucesso = self.$route.params.snackbarSucesso;
        self.snackbarModel.text = self.$route.params.snackbarText;
        self.snackbarModel.mostrar = self.$route.params.snackbarMostrar;
      }
    },
    dataIguaisWidth(datas, hora) {
      if (datas.filter((x) => x.hora === hora).length == 2) {
        return 49;
      } else {
        return 100;
      }
    },
    dataIguaisML(datas, hora, index, idAgenda) {
      const c = datas.filter((x) => x.hora === hora);

      if (c.length == 2) {
        if (c[0].idAgenda == idAgenda) {
          return 0;
        }
        if (c[1].idAgenda == idAgenda) {
          return 50;
        }
      }

      return 0;
    },
    go: function (routeName, routeParams) {
      const self = this;
      if (!routeParams) {
        self.$router.push({ name: routeName });
      } else {
        self.$router.push({ name: routeName, params: routeParams });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 4px;
  margin-right: 8px;
  position: relative;

  &.with-time {
    position: absolute;
    right: 4px;
    margin-right: 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/agenda/Agendas.vue